import React from "react";
import { useSelector } from "react-redux";
import { ILS_CONSTS } from "../../Utils/StaticData/Constant";

const RaceCds = (props) => {
  const [raceCd,setRaceCd]=React.useState([])
  const lang=useSelector((state)=>state.webApp.language)
  const year=useSelector((state1)=>state1.webApp.year)
  const {customerId}=useSelector((state1)=>state1.login)

  const race_En=[
    {
      label:"American Indian or Alaska Native",
      id:"300"
    },
    {
      label:"Asian Indian",
      id:"401"
    },
    {
      label:"Black or African American",
      id:"201"
    },
    {
      label:"Chinese",
      id:"411"
    },
    {
      label:"Filipino",
      id:"421"
    },
    {
      label:"Guamanian or Chamorro",
      id:"521"
    },
    {
      label:"Japanese",
      id:"431"
    },
    {
      label:"Korean",
      id:"441"
    },
    {
      label:"Native Hawaiian",
      id:"501"
    },
    {
      label:"Other Asian",
      id:"499"
    },
    {
      label:"Other Pacific Islander",
      id:"599"
    },
    {
      label:"Samoan",
      id:"511"
    },
    {
      label:"Vietnamese",
      id:"451"
    },
    {
      label:"White",
      id:"101"
    },
    {
      label:"I choose not to answer",
      id:"999"
    },
  ]
  const race_Es=[
    {
      label:"Indio americano o nativo de Alaska",
      id: "300"
    },
    {
      label: "indio asiático",
      id: "401"
    },
    {
      label:"Negro o afroamericano",
      id: "201"
    },
    {
      label: "chino",
      id: "411"
    },
    {
      label:"filipino",
      id: "421"
    },
    {
      label:"Guameño o Chamorro",
      id: "521"
    },
    {
      label: "japonés",
      id: "431"
    },
    {
      label: "coreano",
      id: "441"
    },
    {
      label:"Nativo hawaiano",
      id: "501"
    },
    {
      label:"Otro asiático",
      id: "499"
    },
    {
      label:"Otros isleños del Pacífico",
      id: "599"
    },
    {
      label:"Samoano",
      id: "511"
    },
    {
      label:"vietnamita",
      id: "451"
    },
    {
      label: "Blanco",
      id: "101"
    },
    {
      label:"Elijo no responder",
      id: "999"
    },
  ]
  React.useEffect(()=>{
    let yr=year?.planYear?year.planYear:year;
    if(lang==="en"){
      if(yr==="2024" && customerId===ILS_CONSTS.ID){
        setRaceCd(race_En.filter((race_e)=>race_e.id!=="441"))
      }else{
      setRaceCd(race_En)
      }
    }else if(lang==="es"){
      if(yr==="2024" && customerId===ILS_CONSTS.ID){
        setRaceCd(race_Es.filter((race_s)=>race_s.id!=="441"))
      }else{
      setRaceCd(race_Es)
      }
    }
  },[])
  return (
    <div class="row pl-5 raceCd-font mobile-ethnicity-padding">
      {raceCd.map((r,index)=>
      <div class="col-lg-4 col-md-6 col-sm-12 d-flex flex-row" key={`Race${index}`}>
        <input
          autoComplete="off"
          spellcheck="false"
          //aria-autocomplete="both"
          aria-haspopup="false"
          type="checkbox"
          class="customCheckbox"
          id={r.id}
          name="RACE"
          value={r.id}
          checked={
            props.ethnicityRace?.some((item) => item?.piValue === r.id)
              ? true
              : false
          }
          onChange={props.handleRaceAndEthic}
          // disabled={qsns.disabled}
        />
        <label
          // class="custom-control-label"
          htmlFor={r.id}
        >
          {r.label}
        </label>
      </div>)}
    </div>
  );
};
export default RaceCds;
